export enum CoverageType {
	Residential = 'R',
	Commercial = 'C',
}

export enum BuildingType {
	Public = 'PUBLIC',
	Private = 'PRIVATE',
	Village = 'VILLAGE',
}

export enum Technology {
	DOS = 'DOS',
	ME = 'ME',
	GP = 'GP',
	H5G = '5G',
}

export enum Operator {
	hkbn = 'hkbn',
	hgc = 'hgc',
	icable = 'icable',
}

export enum CustomerType {
	SMC = 'SMC',
	MASS = 'MASS',
	//corpWeb = 'corpWeb',
}

export enum MembershipTier {
	PP = 'PP',
	PPP = 'PPP',
	NONE = '',
	// ignore P / Plus in JSP side
}

export enum Bandwidth {
	b100 = '100',
	b200 = '200',
	b500 = '500',
	b1000 = '1000',
	b2000 = '2000',
}

export enum AddOnType {
	SINGLE = '1', //Just choose it, no options
	CHOOSE1 = '2', //norton case, choose one of the plan
	SUB_ADDON = '3', //hometel case, choose base hometel, then add additional VAS like call forwarding
}

export enum CurrentISP {
	PCCW = 'PCCW',
	HKBN = 'HKBN',
	THREE_HK = '3HK',
	ICABLE = 'ICABLE',
	CMHK = 'CMHK',
	NA = 'NA',
}

export enum PlanTagValue {
	REC = 'REC',
	SHORT = 'SHORT',
	STUDENT = 'STUDENT',

	b100 = '100M',
	b200 = '200M',
	b500 = '500M',
	b1000 = '1000M',
	b2000 = '2000M',
}

export enum RouterOptionConfig {
	None = 0, // no router section
	BuyRentalNot = 1, // AddOnRentalRouter + AddOnRouter + AddOnNoRouter
	FreeRentalOnly = 2, // AddOnRentalRouterFree Only !!
	FreeRentalNot = 3, // AddOnRentalRouterFree + AddOnNoRouter
	BuyFreeRentalNot = 4, // AddOnRentalRouterFree + AddOnRouter + AddOnNoRouter
	BuyRental = 5, // AddOnRentalRouter + AddOnRouter
	FreeRental4Only = 7, // AddOnRentalRouterFree Only !!

	// mesh router will show in both AddOnRentalRouter &　AddOnRouter
	Buy2Rental2Not = 6, // AddOnRentalRouter (show Mesh) + AddOnRouter (show Mesh) + AddOnNoRouter
	Buy2FreeRental3Not = 8, // AddOnRentalRouterFree (show Mesh) + AddOnBuyRouter (show Mesh) + AddOnNoRouter
	Buy2Rental2 = 9, // AddOnRentalRouterFree (show Mesh) + AddOnBuyRouter (show Mesh)
	FreeRental3Only = 10, // AddOnRentalRouterFree (show Mesh) Only !!	
}

export enum PromoMobileExpandConfig {
	Both = 0 /* Allow promo code and mobile number ui  */,
	PromoCodeOnly = 1,
	MobileNumOnly = 2,
	None = 3, // hide this element in ui ?
}

export enum OfflinePaymentType {
	CASH = 'cash',
	CREDITCARD_AUTO = 'creditcard',
	BACKACC_AUTO = 'bankaccount',
}
